











































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import LayerListPanel from '@/components/layers/LayerListPanel.vue';
import FeatureInfosPanel from '@/components/map/FeatureInfosPanel.vue';
import PluginListPanel from '@/components/plugins/PluginListPanel.vue';
import SettingsPanel from '@/components/settings/SettingsPanel.vue';
import Plugin from '@/models/plugin/Plugin';
import { PluginLocation } from '@/models/plugin/PluginLocation';
import { EventBus, EVENTS } from '@/services/EventBus';
import Component from 'vue-class-component';
import BaseComponent from './BaseComponent';
import PresentationPanel from './PresentationPanel.vue';



@Component({
  props: {},
  components: {
    LayerListPanel,
    PresentationPanel,
    PluginListPanel,
    FeatureInfosPanel,
    SettingsPanel,
  },
})
export default class LeftSideBar extends BaseComponent {
  visiblePanel='';

  visiblePluginPanel:Plugin|null=null;

  pluginsToolBar:Plugin[]=[];

  PluginLocation=PluginLocation;

  firstleftSideBarItems= 
    {
      icon: 'info',
      label: 'Informations sur la carte',
      editionOnly: false,
      panel: PresentationPanel.ID,
    }
  ;

  leftSideBarItems = [
    {
      icon: 'gear',
      label: 'Réglages',
      editionOnly: true,
      panel: SettingsPanel.ID,
    },
    {
      icon: 'puzzle',
      label: 'Modules',
      editionOnly: true,
      panel: PluginListPanel.ID,
    },
  ];

  onlyLeftActive(item:Plugin) {
    return (item.isActive ||(item.defaultConfiguration.activeInEdition && this.contextService.isEditionActive)) && item.configuration.position === PluginLocation.LeftToolBar && !(item.isOnly3D && !this.is3DView());
  }

  created() {
    const requireComponent = require.context(
    // The relative path of the components folder
      './plugins/',
      // Whether or not to look in subfolders
      true,
      // The regular expression used to match base component filenames
      /[A-Z]\w+\.(vue|js)$/,
    );

    requireComponent.keys().forEach((fileName:string) => {
      const componentConfig = requireComponent(fileName);
      console.log(componentConfig.default);
      // Gets the file name regardless of folder depth
      if (fileName && fileName.split('/') !== undefined) {
        const fileNameA = fileName.split('/');
        if (fileNameA && fileNameA.length > 0) {
          const fname = fileNameA.pop();
          if (fname && this.$options.components) {
            const componentName = fname.split('.')[0];
            // register the component locally
            this.$options.components[componentName] = componentConfig.default;
          }
        }
      }
    });
  }

  mounted() {
    EventBus.$on(EVENTS.OPEN_LEFT_SIDE_MENU, (menu:any) => this.openMenu(menu));
    EventBus.$on(EVENTS.SELECT_FEATURE, (features:any) => this.onSelectFeature(features));

    console.log('show pres')
    if( this.contextService.currentContext && this.contextService.currentContext.showPresentation){

      this.visiblePanel = PresentationPanel.ID;
    }
  }


  get showInfoMenu(){
    let content:any = this.contextService.currentContext?.presentation;
    if(content==undefined||content.length==0){
      return false;
    }
    return true;
  }
  isIconCustomImg(item:any) {
    return item.configuration.icon && item.configuration.icon.indexOf('.png') > 0;
  }

  onSelectFeature(features:any) {
    if (this.pluginService.isActive(FeatureInfosPanel.NAME)
      && !this.pluginService.getBooleanParameter(FeatureInfosPanel.NAME, FeatureInfosPanel.MOVABLE)) {
      this.openMenu(FeatureInfosPanel.NAME);
    }
  }

  openMenu(menu:string) {
    this.visiblePanel = menu;
  }

  menuActivated(item:any) {
    console.log(item);
    if (item.panel && this.visiblePanel !== item.panel) {
      this.visiblePanel = item.panel;
      this.visiblePluginPanel = null;
    } else {
      this.visiblePanel = '';
      this.visiblePluginPanel = null;
    }
  }

  menuPluginActivated(item:Plugin) {
    console.log(item);
    if (item.componentName && this.visiblePanel !== item.componentName) {
      this.visiblePanel = item.componentName;
      this.visiblePluginPanel = item;
    } else {
      this.visiblePanel = '';
      this.visiblePluginPanel = null;
    }
  }
}
